import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
export function withDimensions(ExternalComponent) {
    var _React_Component, _WithDimensions;
    return _WithDimensions = class WithDimensions extends (_React_Component = React.Component) {
        get width() {
            return this.container ? this.container.clientWidth : 0;
        }
        componentDidMount() {
            this.delayedUpdateWidth();
        }
        UNSAFE_componentWillReceiveProps() {
            this.delayedUpdateWidth();
        }
        componentWillUnmount() {
            this.clearDelayedUpdateWidth();
        }
        delayedUpdateWidth() {
            this.delayedUptadeTimeout = requestAnimationFrame(this.updateWidth);
        }
        clearDelayedUpdateWidth() {
            cancelAnimationFrame(this.delayedUptadeTimeout);
        }
        render() {
            return /*#__PURE__*/ React.createElement("div", {
                style: {
                    width: '100%'
                },
                ref: (container)=>this.container = container
            }, /*#__PURE__*/ React.createElement(ExternalComponent, _object_spread_props(_object_spread({}, this.props), {
                width: this.state.width
            })));
        }
        constructor(props){
            super(props);
            _define_property(this, "container", void 0);
            _define_property(this, "delayedUptadeTimeout", void 0);
            _define_property(this, "updateWidth", ()=>{
                if (this.width !== this.state.width) {
                    this.setState({
                        width: this.width
                    });
                }
            });
            this.state = {
                width: 0
            };
        }
    }, _define_property(_WithDimensions, "sizeClassName", ExternalComponent.sizeClassName), _define_property(_WithDimensions, "alignmentClassName", ExternalComponent.alignmentClassName), _define_property(_WithDimensions, "textWrapClassName", ExternalComponent.textWrapClassName), _WithDimensions;
}

//# sourceMappingURL=withDimensions.js.map